import { Box, Checkbox, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Autosizer, Scrollbar } from 'app/components';
import React from 'react';
import { FixedSizeList } from 'react-window';

const MapFilterReportGeofenceList = (props) => {
  const { items, checkedId, onClick } = props;

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        '.simplebar-offset > div': {
          '&::-webkit-scrollbar': {
            width: 0,
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
            boxShadow: 'none',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        },
      }}>
      <Autosizer>
        {({ height, width }) => (
          <Box sx={{ height, width }}>
            <Scrollbar>
              {({ scrollableNodeRef, contentNodeRef }) => (
                <FixedSizeList
                  itemSize={24}
                  height={height}
                  itemCount={items.length}
                  innerRef={contentNodeRef}
                  outerRef={scrollableNodeRef}
                  itemData={{
                    items,
                    checkedId,
                    onClick,
                  }}>
                  {mapFilterReportGeofenceListItemRender}
                </FixedSizeList>
              )}
            </Scrollbar>
          </Box>
        )}
      </Autosizer>
    </Box>
  );
};

const mapFilterReportGeofenceListItemRender = ({ data, index, style }) => {
  const { items, checkedId, onClick } = data;

  return (
    <ListItem
      key={index}
      style={style}
      onClick={() => onClick(items[index].id)}
      sx={(theme) => ({
        width: '100%',
        userSelect: 'none',
        padding: theme.spacing(0),
        borderRadius: '0',
        '.MuiAvatar-circular': {
          width: '24px',
          height: '24px',
        },
        '.MuiListItemButton-root': {
          height: '100%',
          padding: theme.spacing(0, 2),
          borderRadius: '0',
        },
        '.MuiListItemText-root': {
          margin: theme.spacing(0),
        },
        '.MuiListItemIcon-root': {
          minWidth: '24px',
        },
        '.MuiCheckbox-root': {
          padding: theme.spacing(0),
          marginLeft: '-3px',
          svg: {
            fontSize: '18px',
          },
        },
      })}>
      <ListItemButton>
        <ListItemIcon>
          <Checkbox size='small' edge='end' disableRipple checked={checkedId.includes(items[index].id)} />
        </ListItemIcon>
        <ListItemText primary={items[index].name} />
      </ListItemButton>
    </ListItem>
  );
};

export default MapFilterReportGeofenceList;
